import type { Distance, Pixel, Rectangle } from "@pdfking/renderer-api"

import { RecordMap } from "@pdfking/tfunc"

import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"

export const ConvertRectangle = <T extends Rectangle<Pixel>>(
  options: PdfEngineOptions,
  rect: T
): { [K in keyof T]: Distance } =>
  RecordMap(
    rect,
    (_v, k) => k,
    value => ((value as number) / options.unit_to_px) as Distance
  )
